<template>
    <div class="share-input" v-if="palette">
        <label :for="shareInputID">Share</label>
        <div>
            <input :id="shareInputID" type="text" :value="palette.share_link" readonly>
            <copy-to-clipboard :data-clipboard-target="'#' + shareInputID"></copy-to-clipboard>
        </div>
    </div>
</template>

<script>
    import CopyToClipboard from './CopyToClipboard.vue';

    export default {
    name: "share-url",
    components: { CopyToClipboard },
    props: {
        palette: {},
    },
    computed: {
        shareInputID() {
            return 'share-input-'+this.palette.id;
        }
    }
}
</script>

